import * as utils from './misc.js';


/* ---------------------------------------------
     POPUPS
     --------------------------------------------- */
function get_popup() {
    // console.log("get popup");
    var cookie_popup = utils.getCookie('popup_' + base.currentpageid);

    var today = new Date();

    if (jQuery(".popupcontent").length > 0) {
        var popup = jQuery(".popupcontent");

        var delay = popup.attr("data-delay") || 5;
        var show_on_user_activity = popup.attr("data-show_on_user_activity") || "";
        var show_on_specific_pages = popup.attr("data-show_on_specific_pages") || "";
        var show_frequency = popup.attr("data-show_frequency") || "";
        var every_x_days = popup.attr("data-every_x_days") || "";
        var every_x_pages = popup.attr("data-every_x_pages") || "";
        var popupstyle = popup.attr("data-popupstyle") || "";
        var popupshown = false;
        delay = (show_on_user_activity == "pageloaddelay") ? delay : 0;

        var popupid = jQuery(".popupcontent").attr("data-popupid");
        var popupcontent = `<div class="mfp-with-anim"><div class="popupcontent ` + popupstyle + `">` + jQuery(".popupcontent").html() + `</div></div>`;

        var showpopup = false;
        var lastseen = utils.getCookie('cc_popupid_' + popupid);
        var pageno = utils.getCookie('cc_popupid_no' + popupid) || 0;

        var expiry = today;


        if (show_frequency == "persession" && utils.isnull(lastseen)) {
            showpopup = true;
            expiry = -1;

        } else if (show_frequency == "perddays") {

            if (utils.datediff(lastseen, today) >= every_x_days || utils.isnull(lastseen)) {
                showpopup = true
            }
        } else if (show_frequency == "perpages") {

            if (pageno >= every_x_pages && utils.isnull(lastseen)) {
                //  console.log("show popup")
                showpopup = true
            }
            else {
                // 
                utils.setCookie('cc_popupid_no' + popupid, parseInt(pageno) + 1);
            }
        } else if (show_frequency == "everyvisit") {
            showpopup = true
        }


        if (expiry == -1) {
            //once per session
            if (sessionStorage.getItem('cc_popupid_' + popupid)) {
                showpopup = false
            }
            else {
                sessionStorage.setItem('cc_popupid_' + popupid, today);
            }
        }

        if (showpopup) {

            console.log("show_on_user_activity: " + show_on_user_activity + " popup delay: ", delay)

            utils.setCookie('cc_popupid_' + popupid, today, expiry);

            if (show_on_user_activity == "pageloaddelay") {
                setTimeout(function () {
                    if (!popupshown) {
                        showPopup(popupcontent);
                        popupshown = true;
                    }

                }, delay * 1000);
            }
            else if (show_on_user_activity == "userscroll") {
                jQuery(window).scroll(function () {
                    if (!popupshown) {
                        showPopup(popupcontent);
                        popupshown = true;
                    }
                });
            }
            else if (show_on_user_activity == "none") {
                showPopup(popupcontent);
                popupshown = true;
            }
        }
    }

}

function showPopup(popupcontent) {
    jQuery.magnificPopup.open({
        items: {
            fixedContentPos: true,
            alignTop: true,
            overflowY: 'scroll',
            src: popupcontent,
            type: 'inline'
        },
        callbacks: {
            open: function () {
                jQuery('body').addClass('noscroll');


                //init_carousel();
                var $popup = jQuery('.productpopup');
                jQuery(".productpopup .close-quickview").on('click', function (e) {
                    e.preventDefault();
                    jQuery.magnificPopup.close();
                });

                setTimeout(function () {
                    $popup.addClass('animate-width');
                }, 500);
                setTimeout(function () {
                    $popup.addClass('add-content');
                }, 1000);
            },
            close: function () {
                jQuery('body').removeClass('noscroll');
            }

        },
    });
}

export function init() {
    get_popup();
}